<style>
  /* Remove default list styles */
  .custom-feature-list {
    list-style: none;
    padding: 0;
    margin: 0;
    /* Grid Layout: 2 columns */
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 20px; 
  }

  /* The individual card style */
  .feature-item {
    position: relative;
    display: flex;
    align-items: center;
    padding: 20px 25px; 
    margin-bottom: 0;
    
    /* Glassmorphism Effect */
    background: rgba(255, 255, 255, 0.05);
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 10px; 
    cursor: default;
    transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
    overflow: hidden;
    height: 100%; 
  }

  /* Hover Effects */
  .feature-item:hover {
    transform: translateY(-5px); 
    background: rgba(255, 255, 255, 0.15);
    border-color: rgba(255, 255, 255, 0.4);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);
  }

  /* The circular icon container */
  .feature-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    background: #ffffff;
    border-radius: 50%;
    margin-right: 15px;
    flex-shrink: 0;
    box-shadow: 0 0 10px rgba(255, 255, 255, 0.2);
  }

  /* Text styling */
  .feature-text {
    font-size: 15px; 
    font-weight: 500;
    color: #ffffff;
    letter-spacing: 0.5px;
    line-height: 1.3;
  }

  /* Sliding bar effect */
  .feature-item::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 4px;
    background: #fff;
    transform: scaleY(0);
    transition: transform 0.3s ease;
    transform-origin: bottom;
  }

  .feature-item:hover::before {
    transform: scaleY(1);
    transform-origin: top;
  }

  /* Responsive Adjustments */
  @media (max-width: 768px) {
    .custom-feature-list {
      grid-template-columns: 1fr;
    }
    /* Reset pull-up on mobile so it doesn't overlap header */
    .pull-up {
        margin-top: 0 !important;
    }
    /* Reset image lift on mobile if needed */
    .dollhouse-lift {
        top: 0 !important;
    }
  }

  /* Shift the text column to the left only on large screens */
  @media (min-width: 992px) {
    .custom-offset-left {
      margin-left: -60px; /* Pulls the box closer to the image */
      z-index: 2; /* Ensures it stays visible */
      position: relative;
    }
  }

  /* UPDATED: Significantly pulls elements up */
  .pull-up {
    margin-top: 50px; /* Increased from -50px to -150px */
    position: relative;
    z-index: 999;
  }
  
  /* --- NEW CLASS: Moves the dollhouse image specifically upward --- */
  .dollhouse-lift {
    top: -60px; /* Adjust this value to move it higher or lower */
  }

  /* UPDATED: Highlighted Quote Styling */
  .expert-quote {
    /* Box Styling */
    background: rgba(255, 255, 255, 0.1); /* Subtle background highlight */
    border-left: 5px solid #fff; /* Thicker accent line */
    border-radius: 0 8px 8px 0;
    padding: 25px; /* More breathing room */
    
    /* Text Styling */
    font-style: italic;
    color: #ffffff;
    font-size: 22px; /* Increased text size */
    font-weight: 600; /* Bolder text */
    line-height: 1.5;
    
    /* Positioning */
    margin-top: 50px; /* Pushes it to the bottom */
    box-shadow: 0 4px 15px rgba(0,0,0,0.1);
  }
</style>

<div id="expertise" class="container-fluid overflow-y-hidden bg-base-color bg-sliding-line">
  <div class="row align-items-end flex-column-reverse flex-lg-row">
    
    <div class="col-lg-7 position-relative overflow-hidden">
      <div class="outside-box-bottom-2 outside-box-left-5 pull-up">
        <div class="atropos" data-atropos>
          <div class="atropos-scale">
            <div class="atropos-rotate">
              <div class="atropos-inner text-center overflow-visible">
                <img data-atropos-offset="5" class="position-relative dollhouse-lift" src="assets/images/dollhouse10.png" alt="">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-lg-5 mb-20 mt-6 md-mb-0 custom-offset-left pull-up">
       
      <div class="mb-30px">
        <h4 class="fw-600 text-white mb-2 ls-minus-1px">Why Choose Us</h4>
        <div style="height: 3px; width: 60px; background: #fff; border-radius: 2px;"></div>
      </div>
      
      <ul class="custom-feature-list">
        
        <li class="feature-item">
          <span class="feature-icon">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="12" cy="12" r="10"></circle>
              <polyline points="12 6 12 12 16 14"></polyline>
            </svg>
          </span>
          <span class="feature-text">Save Time Efficiently</span>
        </li>

        <li class="feature-item">
          <span class="feature-icon">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"></path>
              <polyline points="9 11 12 14 22 4"></polyline>
            </svg>
          </span>
          <span class="feature-text">Seamless Conversion</span>
        </li>

        <li class="feature-item">
          <span class="feature-icon">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon>
            </svg>
          </span>
          <span class="feature-text">Lightning-Fast Delivery</span>
        </li>

        <li class="feature-item">
          <span class="feature-icon">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
              <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
            </svg>
          </span>
          <span class="feature-text">Rapid Revisions</span>
        </li>

        <li class="feature-item">
          <span class="feature-icon">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>
            </svg>
          </span>
          <span class="feature-text">High Retention</span>
        </li>

        <li class="feature-item">
          <span class="feature-icon">
             <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
              <circle cx="9" cy="7" r="4"></circle>
              <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
              <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
            </svg>
          </span>
          <span class="feature-text">Less Manpower</span>
        </li>

      </ul>

      <div class="expert-quote">
        "Eliminate repetitive groundwork with expertly crafted templates designed to accelerate your workflow from day one."
      </div>

    </div>
  </div>
</div>